import React from "react";
import { MultiCascader } from 'rsuite';
// import tag from '../data/tag';
import 'rsuite/dist/styles/rsuite-default.css';
import '../css/widget/widget.tageTree.css';

class WidgetTagTree extends React.Component 
{
    constructor(props) 
    {
        super(props);


        this.state = {
            data: props.data,
            values: [],
            isFromState: false,
            //data:tag,
            catalog: [],
            currentCatalog: [],
            param: props.param,
            defaultValues: [],
            checkNodes: props.defaultNodes,
            searchable: props.searchable === true,
            option: props.option,
            width: undefined,
            height: undefined
        }

        this.onSelect = this.onSelect.bind(this);
        this.onChange = this.onChange.bind(this);
        this.buildData = this.buildData.bind(this);
        this.findCatalog = this.findCatalog.bind(this);
        this.findNode = this.findNode.bind(this);
        this.buildGroupData = this.buildGroupData.bind(this);
        this.initTagValue = this.initTagValue.bind(this);

        // 获取组件自身
        this.myRef = React.createRef();
    }

    onChange(values, event) 
    {
        let checkNode = [];
        let { currentCatalog } = this.state;

        let data = this.buildData(this.props.data);

        for (let k in values ) 
        {
            let node = this.findNode(values[k], data, -1);

            // for (let j in currentCatalog) 
            // {
            //     if (node.type === currentCatalog[j].value) 
            //     {
            //         node["parentCatalog"] = currentCatalog[j];

            //         checkNode.push(node);
            //         break;
            //     }
            // }

            if( node!==undefined && node!==null )
            {
                checkNode.push(node);
            }
        }

        if (this.props.onChange !== undefined) 
        {
            this.props.onChange(this.buildGroupData(checkNode), values, event);
        }

        this.setState({ defaultValues: values, isFromState: true });

    }

    onSelect(value, item, event) 
    {

        this.state.currentCatalog.push(value);

        // if ( value.catalog ) 
        // {
           
        // }

        if (this.props.onSelect !== undefined) 
        {
            this.props.onSelect(value, item, event);
        }

        this.setState({ values: value });
    }

    findCatalog(datas) 
    {
        let { catalog } = this.state;

        for (let i = 0; i < datas.length; i++) 
        {
            if (datas[i].catalog) 
            {
                catalog.push(datas[i].value);

                if (datas[i].children !== undefined) 
                {
                    this.findCatalog(datas[i].children);
                }
            }
        }
    }

    findNode(value, data, parentNode) 
    {
        let temp_data, val, key;

        for (key = 0; key < data.length; key++) 
        {
            val = data[key];

            if ( val.value===value )
            {
                let pNode = {};
                
                pNode = {...parentNode};

                delete pNode["children"];

                val["parentCatalog"] = pNode;

                return val;
            }

            if ( val.children!==undefined && val.children.length>0 ) 
            {
                temp_data =  this.findNode(value, val.children, val);

                if ( temp_data ) return temp_data;
            }
        }
    }

    buildGroupData(datas) 
    {
        let array = [], flag = [];
        let obj = {};

        for ( let i in datas ) 
        {
            if (obj[datas[i].parentCatalog.value] === undefined) 
            {
                obj[datas[i].parentCatalog.value] = [];
            }

            obj[datas[i].parentCatalog.value].push(datas[i]);
        }

        for ( let j in datas ) 
        {
            for (let key in obj)
            {
                if ( datas[j].parentCatalog.value===key && !flag.includes(key) ) 
                {
                    array.push(obj[key]);
                    flag.push(key);
                }
            }
        }

        return array;
    }

    buildData(datas) 
    {
        let tag = [];

        if(datas)
        {
            for (let i = 0; i < datas.length; i++) 
            {
                if (tag[i] === undefined) tag[i] = {};

                tag[i]["label"] = datas[i].name;
                tag[i]["value"] = datas[i].code;
                tag[i]["type"] = datas[i].type;
                tag[i]["catalog"] = datas[i].catalog;
                tag[i]["id"] = datas[i].code;

                if (datas[i].subtags !== undefined) 
                {
                    tag[i]["children"] = this.buildData(datas[i].subtags);
                }
            }
        }

        return tag;

    }

    updateRect() 
    {
        if (this.myRef !== undefined && this.myRef !== null && this.myRef.current !== undefined && this.myRef.current !== null) {
            const height = this.myRef.current.parentElement.clientHeight;
            const width = this.myRef.current.parentElement.clientWidth;

            if (this.state.width !== width || this.state.height !== height) 
            {
                this.setState({ width: width, height: height });
            }
        }
    }

    /**
     * 初始化标签value
     * @param {*} values 
     */
    initTagValue( values )
    {
        if( values!==undefined && values.length>0 )
        {
            this.setState({defaultValues:values});
        }
    }

    componentDidMount() 
    {
        this.updateRect();
        this.initTagValue(this.props.defaultValue);
        
    }

    componentDidUpdate() 
    {
        this.updateRect();
    }

    componentWillReceiveProps(nextProps)
    {
        if(nextProps.defaultValue !== this.props.defaultValue){
            
            this.setState({defaultValues:nextProps.defaultValue});
        }
    }

    render() 
    {
        const data = this.buildData(this.props.data);

        this.findCatalog(data);

        let { searchable, option, catalog, height, defaultValues } = this.state;

        return (
            <div className="widget-tag-tree" ref={this.myRef} key={"key"}>
                <MultiCascader 
                    block
                    data={data}
                    onChange={this.onChange}
                    onSelect={this.onSelect}
                    defaultValue={defaultValues}
                    value={defaultValues}
                    searchable={searchable}
                    inline={option.inline}
                    menuHeight={height}
                    menuWidth={200}
                    uncheckableItemValues={catalog}
                    renderMenuItem={(label, item) => {
                        if ( item.catalog ) 
                        {
                            return (
                                <div key={item.id} className="tag-tree-file">
                                    <span className="rs-checkbox-wrapper tag-tree-file-icon"></span>
                                    <div><i className="rs-icon "></i>{label}</div>
                                </div>
                            );
                        }
                        else 
                        {
                            return (
                                <div key={item.id}>
                                    <i className="rs-icon" /> {label}
                                </div>
                            )
                        }

                    }}
                />
            </div>
        );
    }
}

export default WidgetTagTree